// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.rsm-agent-icon {
  margin: 1.25rem 0;
  text-align: center;
}

.policy-content {
  --background: #f0f6f7;
}

ion-spinner {
  display: block;
  margin: 3rem auto;
}

.policy-document {
  padding: 1rem;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.policy-document h1 {
  margin: 0 0 1rem;
  color: #1b1d1d;
  font-size: 1.35rem;
  font-weight: 700;
}

.policy-document pre {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  color: #51565f;
  font-family: inherit;
  font-size: 0.95rem;
  line-height: 1.65;
}

.policy-state {
  padding: 1rem;
  border-radius: 12px;
  background: #ffffff;
  color: #51565f;
  text-align: center;
}

.policy-actions {
  padding: 0.75rem 1rem 1rem;
}

.policy-actions p {
  margin: 0 0 0.75rem;
  color: #51565f;
  font-size: 0.85rem;
  text-align: center;
}

/* ── Termo cadastrado em HTML pelo painel ───────────────────────────────────
   Mesma tipografia do <pre> usado no texto puro, para os dois formatos lerem
   igual. Sem isto o conteúdo sai colado, porque o reset do Ionic zera as
   margens de p/h/ul. */
.policy-document__html {
  color: #51565f;
  font-size: 0.95rem;
  line-height: 1.55;
  word-break: break-word;
  /* O primeiro título repetiria o <h1> do cabeçalho do documento. */
}
.policy-document__html h2, .policy-document__html h3 {
  margin: 1.25rem 0 0.5rem;
  color: #1b1d1d;
  font-weight: 700;
}
.policy-document__html h2 {
  font-size: 1.1rem;
}
.policy-document__html h3 {
  font-size: 1rem;
}
.policy-document__html > h2:first-child,
.policy-document__html > h3:first-child {
  margin-top: 0;
}
.policy-document__html p {
  margin: 0 0 0.85rem;
}
.policy-document__html ul, .policy-document__html ol {
  margin: 0 0 0.85rem;
  padding-left: 1.25rem;
}
.policy-document__html li {
  margin-bottom: 0.35rem;
}
.policy-document__html strong {
  color: #1b1d1d;
}
.policy-document__html a {
  color: var(--rsm-brand);
  word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/policy/policy.page.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,iBAAA;EACA,kBAAA;AAEF;;AACA;EACE,qBAAA;AAEF;;AACA;EACE,cAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;AAEF;;AACA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAEF;;AACA;EACE,SAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAEF;;AACA;;;uBAAA;AAIA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EAWA,kEAAA;AARF;AADE;EACE,wBAAA;EACA,cAAA;EACA,gBAAA;AAGJ;AAAE;EAAK,iBAAA;AAGP;AAFE;EAAK,eAAA;AAKP;AAFE;;EAEE,aAAA;AAIJ;AADE;EACE,mBAAA;AAGJ;AAAE;EACE,mBAAA;EACA,qBAAA;AAEJ;AACE;EACE,sBAAA;AACJ;AAEE;EACE,cAAA;AAAJ;AAGE;EACE,uBAAA;EACA,qBAAA;AADJ","sourcesContent":[".rsm-agent-icon {\n  margin: 1.25rem 0;\n  text-align: center;\n}\n\n.policy-content {\n  --background: #f0f6f7;\n}\n\nion-spinner {\n  display: block;\n  margin: 3rem auto;\n}\n\n.policy-document {\n  padding: 1rem;\n  border-radius: 14px;\n  background: #ffffff;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n}\n\n.policy-document h1 {\n  margin: 0 0 1rem;\n  color: #1b1d1d;\n  font-size: 1.35rem;\n  font-weight: 700;\n}\n\n.policy-document pre {\n  margin: 0;\n  white-space: pre-wrap;\n  word-break: break-word;\n  color: #51565f;\n  font-family: inherit;\n  font-size: 0.95rem;\n  line-height: 1.65;\n}\n\n.policy-state {\n  padding: 1rem;\n  border-radius: 12px;\n  background: #ffffff;\n  color: #51565f;\n  text-align: center;\n}\n\n.policy-actions {\n  padding: 0.75rem 1rem 1rem;\n}\n\n.policy-actions p {\n  margin: 0 0 0.75rem;\n  color: #51565f;\n  font-size: 0.85rem;\n  text-align: center;\n}\n\n/* ── Termo cadastrado em HTML pelo painel ───────────────────────────────────\n   Mesma tipografia do <pre> usado no texto puro, para os dois formatos lerem\n   igual. Sem isto o conteúdo sai colado, porque o reset do Ionic zera as\n   margens de p/h/ul. */\n.policy-document__html {\n  color: #51565f;\n  font-size: 0.95rem;\n  line-height: 1.55;\n  word-break: break-word;\n\n  h2, h3 {\n    margin: 1.25rem 0 0.5rem;\n    color: #1b1d1d;\n    font-weight: 700;\n  }\n\n  h2 { font-size: 1.1rem; }\n  h3 { font-size: 1rem; }\n\n  /* O primeiro título repetiria o <h1> do cabeçalho do documento. */\n  > h2:first-child,\n  > h3:first-child {\n    margin-top: 0;\n  }\n\n  p {\n    margin: 0 0 0.85rem;\n  }\n\n  ul, ol {\n    margin: 0 0 0.85rem;\n    padding-left: 1.25rem;\n  }\n\n  li {\n    margin-bottom: 0.35rem;\n  }\n\n  strong {\n    color: #1b1d1d;\n  }\n\n  a {\n    color: var(--rsm-brand);\n    word-break: break-all;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
